import "./triangle.css"
import React from 'react'

function Triangle() {
  return (
    <>
      <div className="containerTriangle">
        <div className="triangle"></div>
      </div>
    </>
  )
}

export default Triangle